import React, { MouseEventHandler, useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Icon, { ICONS, COLORS } from '../../../../../general-ui/icon';
import { Speaker } from '../../../../../../types/working-model';
import { getTextValue } from '../../../../../../utils/utils';
import { ParamsProps } from '../../../../../live-event/live-event';
import { useParams } from 'react-router';
import { renderSocialLinks } from '../../../../../general-ui/social-links/social-links';
import { useTranslate } from '../../../../../../i18n/useTranslationModules';
import { getNamespaceAdmin } from '../../../../utils/utils';

interface Props {
	speaker: Speaker;
	editSpeaker: (speaker: Speaker) => MouseEventHandler<HTMLButtonElement>;
	checkDeleteSpeaker: (speaker: Speaker) => MouseEventHandler<HTMLButtonElement>;
	replaceSpeaker: (speaker: Speaker) => void;
	id: string;
}

const SpeakerCard: React.FC<Props> = ({ speaker, editSpeaker, checkDeleteSpeaker, id, replaceSpeaker }) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
	} = useSortable({ id });

	const { t } = useTranslate(getNamespaceAdmin());

	const { language }: ParamsProps = useParams();
	const style = {
		transform: CSS.Transform.toString(transform),
		transition: 'none',
	};

	const socialLinks = useMemo(() => {
		return speaker.link_social ? renderSocialLinks(speaker.social_links || []) : null;
	}, [speaker]);
	const { description } = getTextValue(speaker, language);

	const moduleId = speaker.module_id;

	return (
		<li className="speakers-column" ref={setNodeRef} style={style} {...attributes} {...listeners}>
			<div className="speaker">

				<img src={speaker.image} alt={speaker.first_name} />
				<div className="speaker-name-container">
					<h3 className="speaker-name">{speaker.first_name} {speaker.last_name}</h3>
					<h5 className="speaker-job-title">{t(`speaker.${moduleId}.job_title`, (speaker.job_title?.[language] as string ?? speaker.job_title?.base) ?? '')}</h5>
					<p className="speaker-about">{t(`speaker.${moduleId}.description`, description)}</p>
					{socialLinks}
				</div>

				<div className="edit-actions">
					<button className="round" onClick={editSpeaker(speaker)}><Icon name={ICONS.EDIT} size={12} color={COLORS.WHITE} /></button>
					<button className="round" onClick={() => replaceSpeaker(speaker)}><Icon name={ICONS.ARROW_CIRCLE} size={12} color={COLORS.WHITE} /></button>
					<button className="round" onClick={checkDeleteSpeaker(speaker)}><Icon name={ICONS.TRASH_OUTLINE} size={12} color={COLORS.WHITE} /></button>
				</div>
			</div>
		</li>
	);
};

export default SpeakerCard;
